// Nome da tecla de atalho escrito no botão do Balcão ("Enter", "Esc", "F3").
export default function TeclaAtalho({ children, className = "" }) {
  return (
    <kbd className={`inline-flex items-center px-1.5 py-0.5 rounded-md border border-white/30 bg-black/20 text-[11px] font-semibold leading-none opacity-80 ${className}`}>
      {children}
    </kbd>
  );
}
